import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './premioFaixaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaTipo,
	getListaGrupo
} from './premioFaixaActions';

class PremioFaixa extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		ordenacao: {
			nome_tipo: 1
		}
	}

	componentWillMount() {
		this.props.setModoTela('lista');
		this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaGrupo();
	}

	render() {
		return (
			<div>
				<Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}

					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}

					{this.props.modoTela == 'lista' ? this.lista() : null}

				</Content>
			</div>
		)
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i className='fas fa-sort-amount-down-alt' />;
		} else if (tipo == 2) {
			return <i className='fas fa-sort-amount-up' />;
		} else {
			return null;
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = (this.props.lista || []).filter(item => {

			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(pesquisar => (pesquisar || '').trim())
					.filter(pesquisar => {

						if (
							pesquisar
							&& !(
								`
									${item.nome_tipo || ''}
									${item.nome_grupo || ''}
									${item.km_inicio || ''}
									${item.km_fim || ''}
									${FormatUtils.formatarValorTela(item.valor_km, 4) || ''}
									${DateFormat.formatarDataSqlParaTela(item.data_inicio) || ''}
									${DateFormat.formatarDataSqlParaTela(item.data_fim) || ''}
									${item.vigente ? 'Vigente' : 'Não vigente'}
								`
							)
								.toUpperCase()
								.includes(pesquisar)
						) {
							return false;
						}

						return true;

					}).length > 0;

		});

		if (this.state.ordenacao.nome_tipo) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome_tipo == 1
					? ((a.nome_tipo || '') > (b.nome_tipo || '') ? 1 : -1)
					: ((a.nome_tipo || '') > (b.nome_tipo || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.nome_grupo) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome_grupo == 1
					? ((a.nome_grupo || '') > (b.nome_grupo || '') ? 1 : -1)
					: ((a.nome_grupo || '') > (b.nome_grupo || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.km_inicio) {

			lista.sort((a, b) =>
				this.state.ordenacao.km_inicio == 1
					? ((a.km_inicio || 0) > (b.km_inicio || 0) ? 1 : -1)
					: ((a.km_inicio || 0) > (b.km_inicio || 0) ? -1 : 1)
			);

		} else if (this.state.ordenacao.km_fim) {

			lista.sort((a, b) =>
				this.state.ordenacao.km_fim == 1
					? ((a.km_fim || 0) > (b.km_fim || 0) ? 1 : -1)
					: ((a.km_fim || 0) > (b.km_fim || 0) ? -1 : 1)
			);

		} else if (this.state.ordenacao.valor_km) {

			lista.sort((a, b) =>
				this.state.ordenacao.valor_km == 1
					? ((a.valor_km || 0) > (b.valor_km || 0) ? 1 : -1)
					: ((a.valor_km || 0) > (b.valor_km || 0) ? -1 : 1)
			);

		} else if (this.state.ordenacao.data_inicio) {

			lista.sort((a, b) =>
				this.state.ordenacao.data_inicio == 1
					? ((a.data_inicio || '') > (b.data_inicio || '') ? 1 : -1)
					: ((a.data_inicio || '') > (b.data_inicio || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.data_fim) {

			lista.sort((a, b) =>
				this.state.ordenacao.data_fim == 1
					? ((a.data_fim || '') > (b.data_fim || '') ? 1 : -1)
					: ((a.data_fim || '') > (b.data_fim || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.vigente) {

			lista.sort((a, b) =>
				this.state.ordenacao.vigente == 1
					? ((a.vigente ? 1 : 0) > (b.vigente ? 1 : 0) ? 1 : -1)
					: ((a.vigente ? 1 : 0) > (b.vigente ? 1 : 0) ? -1 : 1)
			);
		}

		return (
			<ContentCard>

				<ContentCardBody>

					<Row>

						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.state.pesquisar}
							onChange={value =>
								this.setState({
									...this.state,
									pesquisar: value
								})
							}
						/>

						<div
							style={{
								width: 310,
								marginTop: 8,
								marginLeft: 8
							}}
						>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {
									this.props.getLista();
								}}
							>
								<i className='fas fa-sync-alt'></i>
								{' '}Atualizar
							</a>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}}
							>
								<i className='fas fa-plus'></i>
								{' '}Adicionar
							</a>

							<ExcelFile
								filename={'Faixas de Prêmio'}
								element={
									<a
										className='btn btn-app bg-success'
										style={{
											marginLeft: 2,
											minWidth: 75
										}}
									>
										<i className='fas fa-file-excel'></i>
										{' '}Exportar
									</a>
								}
							>
								<ExcelSheet
									data={lista.map(item => ({
										...item,
										valor_km_exportar: FormatUtils.formatarValorTela(item.valor_km, 4),
										data_inicio_exportar: DateFormat.formatarDataSqlParaTela(item.data_inicio),
										data_fim_exportar: DateFormat.formatarDataSqlParaTela(item.data_fim),
										vigente_exportar: item.vigente ? 'Sim' : 'Não'
									}))}
									name='Faixas de Prêmio'
								>

									<ExcelColumn
										label='Tipo'
										value='nome_tipo'
									/>

									<ExcelColumn
										label='Grupo'
										value='nome_grupo'
									/>

									<ExcelColumn
										label='Início'
										value='km_inicio'
									/>

									<ExcelColumn
										label='Fim'
										value='km_fim'
									/>

									<ExcelColumn
										label='Valor Km'
										value='valor_km_exportar'
									/>

									<ExcelColumn
										label='Início Vigência'
										value='data_inicio_exportar'
									/>

									<ExcelColumn
										label='Fim Vigência'
										value='data_fim_exportar'
									/>

									<ExcelColumn
										label='Vigente'
										value='vigente_exportar'
									/>

								</ExcelSheet>

							</ExcelFile>

						</div>

					</Row>

					<div
						style={{
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768
								? '100%'
								: (
									window.innerWidth < 1093
										? `${window.innerHeight - 300}px`
										: (
											window.innerWidth < 1799
												? `${window.innerHeight - 180}px`
												: (
													window.innerWidth < 4000
														? `${window.innerHeight - 180}px`
														: `${window.innerHeight - 110}px`
												)
										)
								)
						}}
					>

						<Table
							responsive
							border
							striped
							alturaFixa
							maxHeight={
								window.innerWidth < 768
									? '100%'
									: (
										window.innerWidth < 1093
											? `${window.innerHeight - 300}px`
											: (
												window.innerWidth < 1799
													? `${window.innerHeight - 180}px`
													: (
														window.innerWidth < 4000
															? `${window.innerHeight - 180}px`
															: `${window.innerHeight - 110}px`
													)
											)
									)
							}
						>

							<THead>

								<Tr
									backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}
								>

									<Th
										minWidth={160}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													nome_tipo: this.getNovaOrdenacao(
														this.state.ordenacao.nome_tipo
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Tipo {this.getIconeOrdenacao(
											this.state.ordenacao.nome_tipo
										)}
									</Th>

									<Th
										minWidth={160}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													nome_grupo: this.getNovaOrdenacao(
														this.state.ordenacao.nome_grupo
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Grupo {this.getIconeOrdenacao(
											this.state.ordenacao.nome_grupo
										)}
									</Th>

									<Th
										minWidth={90}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													km_inicio: this.getNovaOrdenacao(
														this.state.ordenacao.km_inicio
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Início {this.getIconeOrdenacao(
											this.state.ordenacao.km_inicio
										)}
									</Th>

									<Th
										minWidth={90}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													km_fim: this.getNovaOrdenacao(
														this.state.ordenacao.km_fim
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Fim {this.getIconeOrdenacao(
											this.state.ordenacao.km_fim
										)}
									</Th>

									<Th
										minWidth={110}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													valor_km: this.getNovaOrdenacao(
														this.state.ordenacao.valor_km
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Valor Km {this.getIconeOrdenacao(
											this.state.ordenacao.valor_km
										)}
									</Th>

									<Th
										minWidth={130}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													data_inicio: this.getNovaOrdenacao(
														this.state.ordenacao.data_inicio
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Início Vigência {this.getIconeOrdenacao(
											this.state.ordenacao.data_inicio
										)}
									</Th>

									<Th
										minWidth={130}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													data_fim: this.getNovaOrdenacao(
														this.state.ordenacao.data_fim
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Fim Vigência {this.getIconeOrdenacao(
											this.state.ordenacao.data_fim
										)}
									</Th>

									<Th
										minWidth={85}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													vigente: this.getNovaOrdenacao(
														this.state.ordenacao.vigente
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Vigente {this.getIconeOrdenacao(
											this.state.ordenacao.vigente
										)}
									</Th>

									<Th
										minWidth={150}
										width={150}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
									</Th>

								</Tr>

							</THead>

							<TBody>

								{lista.map((item, i) => (

									<Tr
										key={item.id}
										backgroundColor={
											this.state.linhaSelecionada == item.id
												? '#bcc7eb'
												: (
													i % 2 == 0
														? '#ffffff'
														: '#f5f5f5'
												)
										}
										onClick={() =>
											this.setState({
												...this.state,
												linhaSelecionada: item.id
											})
										}
									>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.nome_tipo}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.nome_grupo}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.km_inicio}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.km_fim}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{FormatUtils.formatarValorTela(
												item.valor_km,
												4
											)}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{DateFormat.formatarDataSqlParaTela(
												item.data_inicio
											)}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{DateFormat.formatarDataSqlParaTela(
												item.data_fim
											)}
										</Td>

										<Td
											alignCenter
											minWidth={85}
										>
											<span
												title={
													item.vigente
														? 'Vigente'
														: 'Não vigente'
												}
												style={{
													display: 'inline-flex',
													alignItems: 'center',
													justifyContent: 'center',
													width: 26,
													height: 26,
													borderRadius: '50%',
													backgroundColor: item.vigente
														? '#28a745'
														: '#adb5bd',
													color: '#ffffff',
													fontSize: 12
												}}
											>
												<i
													className={
														item.vigente
															? 'fas fa-check'
															: 'fas fa-minus'
													}
												/>
											</span>
										</Td>

										<Td
											minWidth={150}
											width={150}
											alignCenter
										>

											<ButtonTable
												type={'primary'}
												icon={'fas fa-copy'}
												visible={true}
												small
												title='Copiar'
												event={() => {
													this.props.salvar({
														...item,
														id: null,
														valor_km: FormatUtils.formatarValorTela(
															item.valor_km,
															4
														),
														data_inicio: DateFormat.formatarDataSqlParaTela(
															DateFormat.getDataPosterior(1)
														),
														data_fim: DateFormat.formatarDataSqlParaTela(
															DateFormat.getDataPosterior(1)
														)
													});
												}}
											/>

											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {

													const registro = {
														...item,
														valor_km: FormatUtils.formatarValorTela(
															item.valor_km,
															4
														),
														data_inicio: DateFormat.formatarDataSqlParaTela(
															item.data_inicio
														),
														data_fim: DateFormat.formatarDataSqlParaTela(
															item.data_fim
														)
													};

													this.props.setModoTela(
														'cadastro',
														registro
													);

													this.props.initForm(
														registro
													);
												}}
											/>

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												event={() => {

													const registro = {
														...item,
														valor_km: FormatUtils.formatarValorTela(
															item.valor_km,
															4
														),
														data_inicio: DateFormat.formatarDataSqlParaTela(
															item.data_inicio
														),
														data_fim: DateFormat.formatarDataSqlParaTela(
															item.data_fim
														)
													};

													this.props.setModoTela(
														'exclusao',
														registro
													);

													this.props.initForm(
														registro
													);
												}}
											/>

										</Td>

									</Tr>

								))}

							</TBody>

						</Table>

					</div>

				</ContentCardBody>

			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.premioFaixa.aguardando,
	modoTela: state.premioFaixa.modoTela,
	lista: state.premioFaixa.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaTipo,
	getListaGrupo
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PremioFaixa);